module.exports = __webpack_public_path__ + "img/summary_phone_img.a1313a1a.svg";